var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "programming" },
    [
      _c(
        "div",
        {
          ref: "programming_left",
          staticClass: "programming_left",
          style: _vm.leftDivStyle
        },
        [
          _c("div", { staticClass: "programming_header" }, [
            _c("span", { staticStyle: { "line-height": "24px" } }, [
              _c("span", {
                staticClass: "el-icon-back",
                attrs: { title: "返回目录" },
                on: { click: _vm.goBack }
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.resourceName))])
            ]),
            _vm._v(" "),
            _vm.userType <= 1
              ? _c(
                  "span",
                  { staticClass: "currentValueBtn" },
                  [
                    _vm._v("\n           允许查看答案\n           "),
                    _c("el-switch", {
                      attrs: {
                        "active-value": "1",
                        "inactive-value": "0",
                        "active-color": "#1890FF",
                        "inactive-color": "#D2D2D7"
                      },
                      on: { change: _vm.setShowAnswer },
                      model: {
                        value: _vm.showAnswer,
                        callback: function($$v) {
                          _vm.showAnswer = $$v
                        },
                        expression: "showAnswer"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "bottomer" }, [
            _c("div", { staticClass: "nava" }, [
              _c(
                "div",
                { staticClass: "nava_tool" },
                _vm._l(_vm.menubar, function(bar, bi) {
                  return bar.show
                    ? _c(
                        "p",
                        {
                          staticClass: "nava_tool_p",
                          class: { activeP: _vm.toolTab === bi },
                          on: {
                            click: function($event) {
                              return _vm.nava_tool_click(bi)
                            }
                          }
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "icon svg-icon",
                              staticStyle: { width: "18px", height: "18px" },
                              attrs: { "aria-hidden": "true" }
                            },
                            [_c("use", { attrs: { "xlink:href": bar.icon } })]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "nava_label" }, [
                            _vm._v(_vm._s(bar.label))
                          ])
                        ]
                      )
                    : _vm._e()
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "nava_menu",
                  class: { activeNava: _vm.toolTab >= 0 }
                },
                [
                  _vm.toolTab === 0
                    ? _c(
                        "div",
                        { staticClass: "nava_steps" },
                        [
                          _vm.has
                            ? _vm._l(_vm.treeData, function(item, index) {
                                return _c(
                                  "p",
                                  {
                                    key: index,
                                    staticClass: "nava_steps_p",
                                    attrs: { title: item.name },
                                    on: {
                                      click: function($event) {
                                        return _vm.activeThisOne(item, index)
                                      }
                                    }
                                  },
                                  [
                                    _c("span", [
                                      _c(
                                        "span",
                                        { staticClass: "nava_steps_span" },
                                        [_vm._v(_vm._s(index + 1))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "nava_steps_name" },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span")
                                  ]
                                )
                              })
                            : _c("el-empty", {
                                attrs: {
                                  "image-size": 50,
                                  description: "本题未设置步骤"
                                }
                              })
                        ],
                        2
                      )
                    : _vm.toolTab === 1
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            height: "100%",
                            padding: "19px",
                            overflow: "auto"
                          }
                        },
                        [
                          _vm.totalScore >= 0 && _vm.has
                            ? _c(
                                "div",
                                { staticClass: "rateBox" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "padding-right": "10px",
                                        "font-size": "12px"
                                      }
                                    },
                                    [_vm._v("完成度:")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-rate", {
                                    attrs: {
                                      disabled: "",
                                      "text-color": "#ff9900",
                                      "score-template": "{value}"
                                    },
                                    model: {
                                      value: _vm.totalScore,
                                      callback: function($$v) {
                                        _vm.totalScore = $$v
                                      },
                                      expression: "totalScore"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.totalScore >= 0 && _vm.has
                            ? _c(
                                "div",
                                { staticClass: "nava_score" },
                                [
                                  _vm.has &&
                                  _vm.treeData[0].event >= 0 &&
                                  _vm.treeData[0].event < 100
                                    ? _vm._l(_vm.treeData, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          { key: index + "score" },
                                          [
                                            item.answer
                                              ? [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "nava_steps_p",
                                                      attrs: {
                                                        title: item.name
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            flex: "1"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "nava_steps_span nava_steps_span_finish"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  index + 1
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "nava_steps_name"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          item.event >= 0 &&
                                                          item.answer
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#1890FF"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "【实操训练】"
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      item.eventWeight >= 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                display: "flex",
                                                                "align-items":
                                                                  "center"
                                                              }
                                                            },
                                                            [
                                                              _c("el-rate", {
                                                                attrs: {
                                                                  disabled: "",
                                                                  "text-color":
                                                                    "#ff9900",
                                                                  "score-template":
                                                                    "{value}"
                                                                },
                                                                model: {
                                                                  value:
                                                                    item.eventWeight,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      item,
                                                                      "eventWeight",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "item.eventWeight"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c("span", {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      item.eventWeight <
                                                                      5,
                                                                    expression:
                                                                      "item.eventWeight < 5"
                                                                  }
                                                                ],
                                                                staticClass:
                                                                  "el-icon-s-operation openBtnIcon",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.openThisComment(
                                                                      item
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  item.answer &&
                                                  item.answer.itData &&
                                                  item.answer.itData[0] &&
                                                  item.answer.itData[0]
                                                    .agreementList &&
                                                  item.eventWeight < 5
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "nava_comment",
                                                          class: {
                                                            nava_comment_open:
                                                              item.open
                                                          }
                                                        },
                                                        _vm._l(
                                                          item.answer.itData[0]
                                                            .agreementList,
                                                          function(
                                                            aitem,
                                                            aindex
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key:
                                                                  aindex +
                                                                  "agreement",
                                                                staticStyle: {
                                                                  margin:
                                                                    "5px 5px 5px 20px",
                                                                  background:
                                                                    "#F8F8F8",
                                                                  padding:
                                                                    "0 10px"
                                                                }
                                                              },
                                                              [
                                                                aitem.comment ||
                                                                aitem.title
                                                                  ? [
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticStyle: {
                                                                            "font-weight":
                                                                              "600"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              aitem.title
                                                                            ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticStyle: {
                                                                            "word-break":
                                                                              "break-all",
                                                                            "line-height":
                                                                              "1.5"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              aitem.comment
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  : _c("p", [
                                                                      _vm._v(
                                                                        "没有配置评分描述语"
                                                                      )
                                                                    ])
                                                              ],
                                                              2
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : item.itData &&
                                                      item.eventWeight < 5
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "nava_comment",
                                                          class: {
                                                            nava_comment_open:
                                                              item.open
                                                          }
                                                        },
                                                        _vm._l(
                                                          item.itData,
                                                          function(
                                                            aitem,
                                                            aindex
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key:
                                                                  aindex +
                                                                  "agreement",
                                                                staticStyle: {
                                                                  margin:
                                                                    "5px 5px 5px 20px",
                                                                  background:
                                                                    "#F8F8F8",
                                                                  padding:
                                                                    "0 10px"
                                                                }
                                                              },
                                                              [
                                                                aitem.comment ||
                                                                aitem.title
                                                                  ? [
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticStyle: {
                                                                            "font-weight":
                                                                              "600"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              aitem.title
                                                                            ) +
                                                                              " "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      !aitem.unitWeight
                                                                        ? _c(
                                                                            "p",
                                                                            {
                                                                              staticStyle: {
                                                                                "word-break":
                                                                                  "break-all",
                                                                                "line-height":
                                                                                  "1.5"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  aitem.comment
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  : _c("p", [
                                                                      _vm._v(
                                                                        "没有配置评分描述语"
                                                                      )
                                                                    ])
                                                              ],
                                                              2
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : Number(
                                                        item.eventWeight
                                                      ) !== 5
                                                    ? _c("el-empty", {
                                                        attrs: {
                                                          "image-size": 50,
                                                          description:
                                                            "暂无评分"
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      })
                                    : _c("el-empty", {
                                        attrs: {
                                          "image-size": 50,
                                          description: "试题中事项未绑定步骤"
                                        }
                                      })
                                ],
                                2
                              )
                            : _c("el-empty", {
                                attrs: {
                                  "image-size": 50,
                                  description: "暂无评分"
                                }
                              })
                        ],
                        1
                      )
                    : _vm.toolTab === 2
                    ? _c("zlNotes", { attrs: { query: _vm.query } })
                    : _vm.toolTab === 3
                    ? _c("zlDiscuss", { attrs: { query: _vm.query } })
                    : _vm.toolTab === 4
                    ? _c("putQuestions", {
                        attrs: { query: _vm.query, resource: _vm.activeOne }
                      })
                    : _vm.toolTab === 5
                    ? _c(
                        "div",
                        { staticStyle: { height: "100%", padding: "19px" } },
                        [
                          _vm.has
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "calc(100% - 41px)",
                                    overflow: "auto"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-size": "16px",
                                        "font-weight": "600",
                                        color: "#42414D"
                                      }
                                    },
                                    [_vm._v("参考答案")]
                                  ),
                                  _vm._v(" "),
                                  _vm.has &&
                                  _vm.treeData[0].event >= 0 &&
                                  _vm.treeData[0].event < 100
                                    ? _vm._l(_vm.treeData, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          { key: index + "score" },
                                          [
                                            item.answer
                                              ? [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "nava_steps_p",
                                                      attrs: {
                                                        title: item.name
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            flex: "1"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "nava_steps_span nava_steps_span_finish"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  index + 1
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "nava_steps_name"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          item.event >= 0 &&
                                                          item.answer
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#1890FF"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "【实操训练】"
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  item.selfContent
                                                    ? _c("div", {
                                                        staticClass:
                                                          "editorShowArea",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            item.selfContent
                                                          )
                                                        }
                                                      })
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "editorShowArea"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "12px",
                                                                color: "#cccccc"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "未设置答案"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      })
                                    : _c("el-empty", {
                                        attrs: {
                                          "image-size": 50,
                                          description: "试题中事项未绑定步骤"
                                        }
                                      })
                                ],
                                2
                              )
                            : _c("el-empty", {
                                attrs: {
                                  "image-size": 50,
                                  description: "未设置步骤，答案需绑定在步骤上"
                                }
                              })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "content"
              },
              [
                _vm.has
                  ? _c("div", { staticClass: "content_header activeRound" }, [
                      _c("span", { staticClass: "item_activeRound" }, [
                        _vm._v(_vm._s(_vm.activeIndex + 1))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item_label" }, [
                        _vm._v(_vm._s(_vm.activeOne.name))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text_content" },
                  _vm._l(_vm.activeOne.imageText, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "type6Item" },
                      [
                        item
                          ? [
                              item.type === 1
                                ? _c("div", {
                                    staticClass: "editorShowArea",
                                    domProps: { innerHTML: _vm._s(item.value) }
                                  })
                                : item.type === 3
                                ? _c("questionRender", {
                                    attrs: {
                                      question: item,
                                      questionAnswer: item.questionAnswer
                                    }
                                  })
                                : item.type === 7
                                ? _c("el-image", {
                                    staticClass: "type6resouce",
                                    style: {
                                      width: item.styleOption.width
                                        ? item.styleOption.width + "%"
                                        : "50%"
                                    },
                                    attrs: {
                                      src: item.value,
                                      "preview-src-list": [item.value]
                                    }
                                  })
                                : item.type === 10
                                ? _c(
                                    "video",
                                    {
                                      staticClass: "video-js type6resouce",
                                      style: {
                                        width: item.styleOption.width + "%"
                                      },
                                      attrs: {
                                        controls: "",
                                        preload: "auto",
                                        controlslist: "nodownload",
                                        "data-setup": "{'example_option':true}"
                                      }
                                    },
                                    [
                                      _c("source", {
                                        staticClass: "video",
                                        attrs: {
                                          src: item.value,
                                          type: "video/mp4"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "vjs-no-js" }, [
                                        _vm._v("不支持播放")
                                      ])
                                    ]
                                  )
                                : item.type === 11
                                ? _c("code-compiler", {
                                    ref: "codeCompiler",
                                    refInFor: true,
                                    attrs: {
                                      readPage: true,
                                      readOnly: "",
                                      refresh: item.value
                                    },
                                    model: {
                                      value: item.value,
                                      callback: function($$v) {
                                        _vm.$set(item, "value", $$v)
                                      },
                                      expression: "item.value"
                                    }
                                  })
                                : item.type === 12
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "bottom",
                                            trigger: "click"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "zl_button zl_blueButton",
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleImport(
                                                    item.value
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("下 载")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                slot: "reference",
                                                size: "mini"
                                              },
                                              slot: "reference"
                                            },
                                            [_vm._v(_vm._s(item.value))]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.activeOne.rightNumber || _vm.activeOne.errorNumber
                  ? _c("div", { staticClass: "eventScoring" }, [
                      _c(
                        "div",
                        {
                          staticClass: "eventScoringL",
                          on: { click: _vm.openEventScoring }
                        },
                        [
                          _vm.eventScoring
                            ? _c("span", { staticClass: "el-icon-arrow-down" })
                            : _c("span", { staticClass: "el-icon-arrow-up" })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "eventScoringContent",
                          class: { eventScoringShow: _vm.eventScoring }
                        },
                        [
                          _c("div", { staticClass: "eventScoringHead" }, [
                            _c(
                              "span",
                              { staticClass: "eventScoringHeadItem" },
                              [
                                _c("span", {
                                  staticClass: "el-icon-success",
                                  staticStyle: { color: "#67C23A" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "eventScoringHeadNumber" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.activeOne.rightNumber || 0)
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "eventScoringHeadItem" },
                              [
                                _c("span", {
                                  staticClass: "el-icon-error",
                                  staticStyle: { color: "#F56C6C" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "eventScoringHeadNumber" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.activeOne.errorNumber || 0)
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "eventScoringHeadItem" },
                              [
                                _c("span", {
                                  staticClass: "el-icon-menu",
                                  staticStyle: { color: "#999999" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "eventScoringHeadNumber" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.activeOne.rightNumber +
                                            _vm.activeOne.errorNumber || 0
                                        )
                                    )
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.platform === "codeBlockOS"
                            ? _c(
                                "div",
                                _vm._l(_vm.activeOne.itData, function(
                                  ititem,
                                  itindex
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: itindex + "a",
                                      staticClass: "agreementP"
                                    },
                                    [
                                      _c("span", { staticClass: "aptitle" }, [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#666666",
                                              "font-weight": "600"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                ititem.title
                                                  ? ititem.title
                                                  : "评分点" + itindex + 1
                                              ) + ": "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !ititem.unitWeight
                                          ? _c("span", [
                                              _vm._v(_vm._s(ititem.comment))
                                            ])
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        ititem.unitWeight
                                          ? _c("span", {
                                              staticClass: "el-icon-success",
                                              staticStyle: { color: "#67C23A" }
                                            })
                                          : _c("span", {
                                              staticClass: "el-icon-error",
                                              staticStyle: { color: "#F56C6C" }
                                            })
                                      ])
                                    ]
                                  )
                                }),
                                0
                              )
                            : _c(
                                "div",
                                _vm._l(_vm.activeOne.itData, function(
                                  ititem,
                                  itindex
                                ) {
                                  return _c(
                                    "div",
                                    { key: itindex + "a" },
                                    _vm._l(ititem.agreementList, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "p",
                                        {
                                          key: index + "b",
                                          staticClass: "agreementP"
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "aptitle" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "#666666",
                                                    "font-weight": "600"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.title
                                                        ? item.title
                                                        : "评分点" + index + 1
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !item.unitWeight
                                                ? _c("span", [
                                                    _vm._v(_vm._s(item.comment))
                                                  ])
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            item.unitWeight
                                              ? _c("span", {
                                                  staticClass:
                                                    "el-icon-success",
                                                  staticStyle: {
                                                    color: "#67C23A"
                                                  }
                                                })
                                              : _c("span", {
                                                  staticClass: "el-icon-error",
                                                  staticStyle: {
                                                    color: "#F56C6C"
                                                  }
                                                })
                                          ])
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                }),
                                0
                              )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "content_footer" }, [
                  _vm.activeIndex > 0
                    ? _c(
                        "span",
                        {
                          staticClass: "courseSubBtn zl_button zl_whiteButton",
                          on: { click: _vm.prev }
                        },
                        [_vm._v("上一步")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "courseSubBtn zl_button zl_blueButton",
                      staticStyle: { margin: "0 20px" },
                      on: { click: _vm.goToScore }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.treeData.length == 1
                              ? "测评"
                              : _vm.activeOne.errorNumber
                              ? "重新测评"
                              : "下一步"
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.activeOne.errorNumber && !_vm.isEnd
                    ? _c(
                        "span",
                        { staticClass: "skip", on: { click: _vm.next } },
                        [_vm._v("跳过")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEnd
                    ? _c(
                        "span",
                        {
                          staticClass: "nextSection",
                          on: { click: _vm.nextSection }
                        },
                        [_vm._v("\n              学习下一节\n            ")]
                      )
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.toolTab >= 0
              ? _c("div", {
                  staticClass: "bottomerMask",
                  on: {
                    click: function($event) {
                      _vm.toolTab = -1
                    }
                  }
                })
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "programming_line",
        on: {
          mousedown: function($event) {
            $event.stopPropagation()
            return _vm.lineMove($event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "programming_right" },
        [
          _c("it-env", {
            ref: "itEnv",
            attrs: {
              "iframe-src": _vm.getIframeUrl(),
              "platform-type": _vm.platform,
              codeRefresh: _vm.bindingSort,
              "show-tools-box": true
            },
            on: {
              itEnvMessage: _vm.setLoading,
              itEnvOutput: _vm.itEnvOutput,
              itEnvScore: _vm.getITScore
            },
            model: {
              value: _vm.taskData,
              callback: function($$v) {
                _vm.taskData = $$v
              },
              expression: "taskData"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showRate
        ? _c("zl-rate", {
            attrs: { nextClick: _vm.nextSection, closeFn: _vm.closeFn },
            model: {
              value: _vm.totalScore,
              callback: function($$v) {
                _vm.totalScore = $$v
              },
              expression: "totalScore"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("temporary-interaction", {
        attrs: {
          "common-data": _vm.getInteractionData(),
          "user-type": _vm.userType,
          showToolsBox: _vm.showToolsBox
        }
      }),
      _vm._v(" "),
      _c("office-re-edit", {
        attrs: {
          showToolsBox: _vm.showToolsBox && String(_vm.userType) !== "2",
          "tool-bt-status": [
            { isHide: _vm.getIsHide(), name: "prePage" },
            { isHide: _vm.getIsHide(), name: "nextPage" }
          ],
          "init-questions-request-data": _vm.getUploadFileData()
        },
        on: { prev: _vm.prev, next: _vm.next, openSide: _vm.openSide }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7e71fe2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7e71fe2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/IT/programming.vue
// module id = null
// module chunks = 